// For running the application locally, please update the below values with your local Entra SSO configuration
const ENTRA_AUTH_CONFIG = {
    ENTRA_SSO_BASE_PATH: process.env.REACT_APP_ENTRA_SSO_BASE_PATH,
    AUTHORISATION_URL: '/oauth2/v2.0/authorize', 
    TOKEN_URL: '/oauth2/v2.0/token',
	ENTRA_SSO_CLIENT_ID: process.env.REACT_APP_ENTRA_SSO_CLIENT_ID,
    GRANT_TYPE: 'authorization_code',
    GRANT_TYPE_REFRESH: 'refresh_token',
	RESPONSE_TYPE: 'code',
	SCOPE: 'openid profile',
    TOKEN_SCOPE: process.env.REACT_APP_ENTRA_TOKEN_API_SCOPE, 
    SSO_REDIRECT_URI: process.env.REACT_APP_SSO_REDIRECT_URI,
}

export default ENTRA_AUTH_CONFIG;